import { useRef } from "react";
import { motion, MotionValue, useScroll, useTransform } from "framer-motion";
import { Reveal } from "@/components/site/Motion";

const TEXT = "You already know what to do. You just can't do it every day.";

function Word({ word, i, total, progress }: { word: string; i: number; total: number; progress: MotionValue<number> }) {
  const start = i / total;
  const opacity = useTransform(progress, [start, start + 1 / total], [0.28, 1]);
  const accent = word.startsWith("every") || word.startsWith("day");
  return (
    <motion.span style={{ opacity }} className={`mr-[0.22em] inline-block ${accent ? "italic text-gold-soft" : ""}`}>
      {word}
    </motion.span>
  );
}

export function Statement() {
  const ref = useRef<HTMLDivElement>(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start 0.85", "end 0.45"] });
  const words = TEXT.split(" ");
  return (
    <section data-testid="statement-section" className="grain relative overflow-hidden bg-forest py-24 text-cream sm:py-36">
      <div className="wrap relative">
        <p className="eyebrow-dark">The honest truth</p>
        <div ref={ref}>
          <h2 className="mt-8 max-w-5xl text-[2.6rem] leading-[1.04] sm:text-6xl lg:text-[5.4rem]" data-testid="statement-heading">
            {words.map((w, i) => <Word key={i} word={w} i={i} total={words.length} progress={scrollYProgress} />)}
          </h2>
        </div>
        <div className="mt-14 grid gap-8 sm:grid-cols-2 lg:ml-auto lg:max-w-3xl">
          <Reveal><p className="text-base leading-relaxed text-cream/85 sm:text-lg">That isn't a willpower problem. It's a support problem. Diet charts tell you what to eat. Nobody shows up on the busy Tuesday when the plan falls apart.</p></Reveal>
          <Reveal delay={0.12}><p className="text-base leading-relaxed text-cream/85 sm:text-lg">That's what we do. Coaching that stays with you through the ordinary days, so healthy stops being a project and starts being your normal.</p></Reveal>
        </div>
      </div>
    </section>
  );
}
